import 'lazysizes';
const modules = Array.from(document.querySelectorAll('[data-module]'));

document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if(bg){
      e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

modules.forEach((module) => {
  const componentName = module.getAttribute('data-module');

  import(`./components/${componentName}.js`)
    .then((component) => {
      if (component && component.default) {
        new component.default({
          target: module
        });
      }
    })
    .catch((error) => {
      console.warn(`${componentName}.js failed to load`, error);
    });
});
